<!--
    理论练习
    需要拿到异步数据之后再调用该组件
-->
<template>
    <div class="m-paper m-paperPractice">

        <header class="paper-header">
            <div class="paper-title">
                <img src="../../assets/images/common/nav_logo.png" alt="">
                <h1>{{$t('exam.practiceTitle')}}</h1>
                <el-button @click="closeFn" type="danger" size="small" round><i class="nucfont inuc-close"></i>
                </el-button>
            </div>
            <div class="paper-info">
                <ul>
                    <li>
                        <h5>{{$t('exam.totalCount')}}</h5>
                        <p><b>{{topics.length}}</b> {{$t('exam.question')}}</p>
                    </li>
                    <li class="switch-mode">
                        <el-radio-group v-model="multiMode" size="medium">
                            <el-radio-button :label="true">{{$t('exam.multiMode')}}</el-radio-button>
                            <el-radio-button :label="false">{{$t('exam.singleMode')}}</el-radio-button>
                        </el-radio-group>
                    </li>
                </ul>
            </div>
        </header>

        <div class="paper-container">
            <div class="paper-main" v-if="topics.length">

                <aside class="paper-aside">
                    <div class="paper-aside-inner">
                        <div class="aside-box">
                            <h2 class="box-header">{{$t('exam.answerSheet')}}</h2>
                            <div class="status-desc">
                                <p><span class="done"></span>{{$t('exam.answered')}}</p>
                                <p><span class="undone"></span>{{$t('exam.blank')}}</p>
                            </div>
                            <div class="box-sheet">
                                <div class="sheet-list-wrap" v-for="(obj, key) in multiTopic" v-if="obj.length">
                                    <h3> {{[$t('paper.single'), $t('paper.multiple'), $t('paper.trueOrFalse'), $t('paper.matching')][key - 1]}}</h3>
                                    <ul class="sheet-list">
                                        <li v-for="item in obj"
                                            :class="[{'active' : item.index+1 === number}, sheetStatus(item.id)]"
                                            @click="toNumber(item.index+1)">{{item.index+1}}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="btn-submit">
                                <el-button @click="toSubmit" type="primary">{{$t('exam.submit')}}</el-button>
                            </div>
                        </div>
                    </div>
                </aside>

                <div v-if="multiMode" class="paper-left mode-multi">
                    <section class="paper-list" v-for="(obj, key) in multiTopic" v-if="obj.length">
                        <h2 class="box-header">
                            {{[$t('paper.single'), $t('paper.multiple'), $t('paper.trueOrFalse'), $t('paper.matching')][key - 1]}}</h2>
                        <!-- 题目开始 -->
                        <div class="paper-item" v-for="(item, index) in obj" :key="index" :index="item.index">
                            <div class="detail">
                                <!-- 题干 -->
                                <div class="topic-title">
                                    <p class="no">{{item.index + 1}}.</p>
                                    <!--<span class="type">【{{[$t('paper.single'), $t('paper.multiple'), $t('paper.trueOrFalse')][item.type - 1]}}】</span>-->
                                    <p class="titleRT" v-html="item.titleRT"></p>
                                </div>

                                <!-- 选项 -->
                                <div>
                                    <el-radio-group v-if="item.type === 1" v-model="response[item.id]"
                                                    @change="radioChange">
                                        <el-radio class="topic-choice"
                                                  v-for="v in item.options"
                                                  @click.native="multiRadioClick"
                                                  :label="v.id" :key="v.id">
                                            <em>{{v.tagName}}.</em>
                                            <div class="options" v-html="v.titleRT"></div>
                                        </el-radio>
                                    </el-radio-group>

                                    <template v-if="item.type === 2">
                                        <el-checkbox-group v-model="response[item.id]">
                                            <el-checkbox class="topic-choice" v-for="v in item.options" :label="v.id"
                                                         :key="v.id">
                                                <em>{{v.tagName}}.</em>
                                                <div class="options" v-html="v.titleRT"></div>
                                            </el-checkbox>
                                        </el-checkbox-group>
                                    </template>

                                    <el-radio-group v-if="item.type === 3" v-model="response[item.id]"
                                                    @change="radioChange">
                                        <el-radio class="topic-choice"
                                                  v-for="v in item.options"
                                                  @click.native="multiRadioClick"
                                                  :label="v.id" :key="v.id">
                                            <em>{{v.tagName}}</em>
                                        </el-radio>
                                    </el-radio-group>
                                </div>
                                <div class="match-topic" v-if="item.type == 4"  v-viewer="{movable: false}">
                                    <div class="match-wrap">
                                        <div class="image">
                                            <img :src="item.picViewUrl ? item.picViewUrl : ''" alt="">
                                        </div>

                                    </div>
                                    <div class="match-drag-area">
                                        <div class="drop-area">
                                            <div class="drop-item">
                                                <label class="item-tag">A.</label>
                                                <draggable class="drop-group" :class="{'selected':item.dropList1.length>0}"
                                                        element="div"
                                                        v-model="item.dropList1"
                                                        :options="{group: { name: 'm'+item.id,pull: false},sort: false}"
                                                        :disabled="flag(item.dropList1)"
                                                >

                                                    <div v-if="item.dropList1.length>0">
                                                        <span class="item-name">{{getItem(item.dropList1)}}</span>
                                                    </div>
                                                </draggable>
                                                <p class="item-delete">
                                                    <span v-if="item.dropList1.length>0" class="nucfont inuc-incorrect" @click="deleteItem(1,item)"></span>
                                                </p>
                                            </div>
                                            <div class="drop-item">
                                                <label class="item-tag">B.</label>
                                                <draggable class="drop-group" :class="{'selected':item.dropList2.length>0}"
                                                        element="div"
                                                        v-model="item.dropList2"
                                                        :options="{group: { name: 'm'+item.id,pull: false},sort: false}"
                                                        :disabled="flag(item.dropList2)"
                                                >
                                                    <div v-if="item.dropList2.length>0">
                                                        <span class="item-name">{{getItem(item.dropList2)}}</span>
                                                    </div>

                                                </draggable>
                                                <p class="item-delete">
                                                    <span v-if="item.dropList2.length>0" class="nucfont inuc-incorrect" @click="deleteItem(2,item)"></span>
                                                </p>
                                            </div>
                                            <div class="drop-item" v-if="item.rectangleOptions.length>2">
                                                <label class="item-tag">C.</label>
                                                <draggable class="drop-group" :class="{'selected':item.dropList3.length>0}"
                                                        element="div"
                                                        v-model="item.dropList3"
                                                        :options="{group: { name: 'm'+item.id,pull: false},sort: false}"
                                                        :disabled="flag(item.dropList3)"
                                                >
                                                    <div v-if="item.dropList3.length>0">
                                                        <span class="item-name">{{getItem(item.dropList3)}}</span>
                                                    </div>
                                                </draggable>
                                                <p class="item-delete">
                                                    <span v-if="item.dropList3.length>0" class="nucfont inuc-incorrect" @click="deleteItem(3,item)"></span>
                                                </p>
                                            </div>
                                            <div class="drop-item" v-if="item.rectangleOptions.length >3">
                                                <label class="item-tag">D.</label>
                                                <draggable class="drop-group" :class="{'selected':item.dropList4.length>0}"
                                                        element="div"
                                                        v-model="item.dropList4"
                                                        :options="{group: { name: 'm'+item.id,pull: false},sort: false}"
                                                        :disabled="flag(item.dropList4)"
                                                >
                                                    <div v-if="item.dropList4.length>0">
                                                        <span class="item-name">{{getItem(item.dropList4)}}</span>
                                                    </div>
                                                </draggable>
                                                <p class="item-delete">
                                                    <span v-if="item.dropList4.length>0" class="nucfont inuc-incorrect" @click="deleteItem(4,item)"></span>
                                                </p>
                                            </div>
                                        </div>
                                        <draggable class="list-group"
                                                element="div"
                                                v-model="item.pairOptions"
                                                :options="{group: { name: 'm'+item.id,put: false},ghostClass: 'ghost',sort: false}"
                                                :move="onMove"
                                                @end="onEnd">
                                            <div class="drag-item" v-for="(itm,idx) in item.pairOptions" :key="'md'+idx">
                                                {{itm.value}}
                                            </div>
                                        </draggable>
                                    </div>
                                </div>


                            </div>
                        </div>
                        <!-- 题目结束 -->
                    </section>
                </div>

                <section v-else class="paper-left mode-single">
                    <section class="paper-list">
                        <h2 class="box-header">
                            {{[$t('paper.single'), $t('paper.multiple'), $t('paper.trueOrFalse'),$t('paper.matching')][singleTopic.type - 1]}}</h2>
                        <!-- 题目开始 -->
                        <div class="paper-item">
                            <div class="detail">
                                <!-- 题干 -->
                                <div class="topic-title">
                                    <p class="no">{{number}}.</p>
                                    <!--<span class="type">【{{[$t('paper.single'), $t('paper.multiple'), $t('paper.trueOrFalse')][singleTopic.type - 1]}}】</span>-->
                                    <p class="titleRT" v-html="singleTopic.titleRT"></p>
                                </div>

                                <!-- 选项 -->
                                <div>
                                    <el-radio-group v-if="singleTopic.type === 1" v-model="response[singleTopic.id]"
                                                    @change="radioChange">
                                        <el-radio class="topic-choice" v-for="v in singleTopic.options" :label="v.id"
                                                  :key="v.id">
                                            <em>{{v.tagName}}.</em>
                                            <div class="options" v-html="v.titleRT"></div>
                                        </el-radio>
                                    </el-radio-group>

                                    <template v-if="singleTopic.type === 2">
                                        <el-checkbox-group v-model="response[singleTopic.id]">
                                            <el-checkbox class="topic-choice" v-for="v in singleTopic.options"
                                                         :label="v.id"
                                                         :key="v.id">
                                                <em>{{v.tagName}}.</em>
                                                <div class="options" v-html="v.titleRT"></div>
                                            </el-checkbox>
                                        </el-checkbox-group>
                                    </template>

                                    <el-radio-group v-if="singleTopic.type === 3" v-model="response[singleTopic.id]"
                                                    @change="radioChange">
                                        <el-radio class="topic-choice" v-for="v in singleTopic.options" :label="v.id"
                                                  :key="v.id">
                                            <em>{{v.tagName}}</em>
                                        </el-radio>
                                    </el-radio-group>
                                </div>
                                <div class="match-topic" v-if="singleTopic.type == 4"  v-viewer="{movable: false}">
                                    <div class="match-wrap">
                                        <div class="image">
                                            <img :src="singleTopic.picViewUrl ? singleTopic.picViewUrl : ''" alt="">
                                        </div>
                                    </div>
                                    <div class="match-drag-area">
                                        <div class="drop-area">
                                            <div class="drop-item">
                                                <label class="item-tag">A.</label>
                                                <draggable class="drop-group" :class="{'selected':singleTopic.dropList1.length>0}"
                                                        element="div"
                                                        v-model="singleTopic.dropList1"
                                                        :options="{group: { name: 'm'+singleTopic.id,pull: false},sort: false}"
                                                        :disabled="flag(singleTopic.dropList1)"
                                                >

                                                    <div v-if="singleTopic.dropList1.length>0">
                                                        <span class="item-name">{{getItem(singleTopic.dropList1)}}</span>
                                                    </div>
                                                </draggable>
                                                <p class="item-delete">
                                                    <span v-if="singleTopic.dropList1.length>0" class="nucfont inuc-incorrect" @click="deleteItem(1,singleTopic)"></span>
                                                </p>
                                            </div>
                                            <div class="drop-item">
                                                <label class="item-tag">B.</label>
                                                <draggable class="drop-group" :class="{'selected':singleTopic.dropList2.length>0}"
                                                        element="div"
                                                        v-model="singleTopic.dropList2"
                                                        :options="{group: { name: 'm'+singleTopic.id,pull: false},sort: false}"
                                                        :disabled="flag(singleTopic.dropList2)"
                                                >
                                                    <div v-if="singleTopic.dropList2.length>0">
                                                        <span class="item-name">{{getItem(singleTopic.dropList2)}}</span>
                                                    </div>

                                                </draggable>
                                                <p class="item-delete">
                                                    <span v-if="singleTopic.dropList2.length>0" class="nucfont inuc-incorrect" @click="deleteItem(2,singleTopic)"></span>
                                                </p>
                                            </div>
                                            <div class="drop-item" v-if="singleTopic.rectangleOptions.length>2">
                                                <label class="item-tag">C.</label>
                                                <draggable class="drop-group" :class="{'selected':singleTopic.dropList3.length>0}"
                                                        element="div"
                                                        v-model="singleTopic.dropList3"
                                                        :options="{group: { name: 'm'+singleTopic.id,pull: false},sort: false}"
                                                        :disabled="flag(singleTopic.dropList3)"
                                                >
                                                    <div v-if="singleTopic.dropList3.length>0">
                                                        <span class="item-name">{{getItem(singleTopic.dropList3)}}</span>
                                                    </div>
                                                </draggable>
                                                <p class="item-delete">
                                                    <span v-if="singleTopic.dropList3.length>0" class="nucfont inuc-incorrect" @click="deleteItem(3,singleTopic)"></span>
                                                </p>
                                            </div>
                                            <div class="drop-item" v-if="singleTopic.rectangleOptions.length >3">
                                                <label class="item-tag">D.</label>
                                                <draggable class="drop-group" :class="{'selected':singleTopic.dropList4.length>0}"
                                                        element="div"
                                                        v-model="singleTopic.dropList4"
                                                        :options="{group: { name: 'm'+singleTopic.id,pull: false},sort: false}"
                                                        :disabled="flag(singleTopic.dropList4)"
                                                >
                                                    <div v-if="singleTopic.dropList4.length>0">
                                                        <span class="item-name">{{getItem(singleTopic.dropList4)}}</span>
                                                    </div>
                                                </draggable>
                                                <p class="item-delete">
                                                    <span v-if="singleTopic.dropList4.length>0" class="nucfont inuc-incorrect" @click="deleteItem(4,singleTopic)"></span>
                                                </p>
                                            </div>
                                        </div>
                                        <draggable class="list-group"
                                                element="div"
                                                v-model="singleTopic.pairOptions"
                                                :options="{group: { name: 'm'+singleTopic.id,put: false},ghostClass: 'ghost',sort: false}"
                                                :move="onMove"
                                                @end="onEnd">
                                            <div class="drag-item" v-for="(itm,idx) in singleTopic.pairOptions" :key="'md'+idx">
                                                {{itm.value}}
                                            </div>
                                        </draggable>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </section>
                    <!-- 题目结束 -->

                    <div class="button-group">
                        <el-button @click="lastOne" :disabled="number === 1">{{$t('exam.prev')}}
                        </el-button>
                        <el-button @click="nextOne" :disabled="number === topics.length">
                            {{$t('exam.next')}}
                        </el-button>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
    import api from '@/api';
    import {screenfull} from '@/utils';

    export default {
        components: {},

        props: {
            // 试卷总数据
            examData: {
                required: true,
            },
        },
        data() {
            let response = {};
            this.examData.response.forEach(item => {
                response[item.topicID] = item.answer;
            });
            this.examData.topics.forEach(item => {
                if(item.type==4){
                    item.dropList1 = []
                    item.dropList2 = []
                    item.dropList3 = []
                    item.dropList4 = []
                }
            });

            return {
                number: 1,             //当前的题号
                multiMode: true,
                singleTopic: null,
                multiTopic: null,
                response: response,
            }
        },
        created() {
            console.log('试卷总数据', this.examData);
        },
        mounted() {
            this.$scrollElement = $('.paper-container');

            this.initKeyboard()
        },
        computed: {
            /**
             *  topics: 题目数据
             */
            topics() {
                let topic;

                topic = this.examData.topics;

                topic.forEach((item, index) => {
                    item.index = index;
                });

                this.singleTopic = topic[this.number - 1];
                this.multiTopic = {
                    1: topic.filter(item => item.type === 1),
                    2: topic.filter(item => item.type === 2),
                    3: topic.filter(item => item.type === 3),
                    4: topic.filter(item => item.type === 4)
                };

                return topic;
            },
        },
        methods: {
            onEnd(){
                this.dropResponse();
            },
            flag(data) {
                let flag = false
                if(data.length>0){
                    flag = true
                }
                return flag
            },
            getItem(data){
                if(data.length>0){
                    return data[0].value
                }
            },
            deleteItem(type, data) {
                let index = this.examData.topics.findIndex(v => v.id == data.id)
                switch (type) {
                    case 1:
                        this.examData.topics[index].pairOptions.push(data.dropList1[0])
                        this.examData.topics[index].dropList1 = []
                        break;
                    case 2:
                        this.examData.topics[index].pairOptions.push(data.dropList2[0])
                        this.examData.topics[index].dropList2 = []
                        break;
                    case 3:
                        this.examData.topics[index].pairOptions.push(data.dropList3[0])
                        this.examData.topics[index].dropList3 = []
                        break;
                    case 4:
                        this.examData.topics[index].pairOptions.push(data.dropList4[0])
                        this.examData.topics[index].dropList4 = []
                        break;
                }
                this.dropResponse()
            },
            dropResponse(){
                for (let id in this.response) {
                    this.examData.topics.forEach(itm => {
                        if(id == itm.id && itm.type==4){
                            this.response[id] = []
                            let len = itm.dropList1.length + itm.dropList2.length +itm.dropList3.length +itm.dropList4.length
                            if(len == itm.rectangleOptions.length){
                                this.response[id].push(itm.dropList1[0].id)
                                if(itm.dropList2.length>0){
                                    this.response[id].push(itm.dropList2[0].id)
                                }
                                if(itm.dropList3.length>0){
                                    this.response[id].push(itm.dropList3[0].id)
                                }
                                if(itm.dropList4.length>0){
                                    this.response[id].push(itm.dropList4[0].id)
                                }
                            }
                        }
                    });
                }

            },

            radioChange(val) {
                console.log(this.response);
            },

            // 多题模式下，点击单选和判断滑动到下一题
            multiRadioClick(e) {
                let thisIndex = ~~$(e.target).closest('.paper-item').attr('index');

                let isRepeat = thisIndex === 0 && this.number === 2 ||
                    thisIndex !== 0 && this.number === thisIndex + 1;
                let isLast = thisIndex === this.multiTopic[1].length - 1 ||
                    thisIndex >= this.topics.length - 1;

                // 防止重复触发事件、最后一题不处理
                if (isRepeat || isLast) {
                    return;
                }

                this.number = thisIndex + 1;

                let pos = $("[index=" + (thisIndex + 1) + "]").position().top - 30;
                this.$scrollElement.animate({scrollTop: pos}, 500);
            },

            toSubmit() {
                console.log('提交的数据', this.response);
                let checkedNum = $('.sheet-list').find('.check').length;
                let leftNum = this.topics.length - checkedNum;
                let msg = leftNum > 0 ? this.$t('m.submitUndonePaper', [leftNum]) : this.$t('m.submitPaper');

                this.$confirm(msg, this.$t('m.tip'), {
                    type: 'warning'
                }).then(() => {
                    this.submitPaper();
                }).catch(() => {
                });
            },
            submitPaper() {
                let submitData = [];

                this.$emit('submit', this.response);

                for (let id in this.response) {
                    submitData.push({
                        topicID: id,
                        answer: this.response[id],
                        result: false
                    })
                }

                api.submitTheoryStudy(this.examData.guid, submitData)
                    .then(res => {
                        return api.theoryStudyAchievement(res.package);
                    })
                    .then(res => {
                        let data = res.package;
                        //let msg = `本次练习共包含 ${data.total} 题，作答正确 ${data.correct} 题`;
                        let msg = this.$t('m.practiceResult', [data.total, data.correct]);

                        this.$alert(msg, this.$t('exam.practiceResult'), {
                            confirmButtonText: this.$t('m.confirm'),
                        }).then(() => {
                            this.afterCloseResult(data.id);
//                            this.$emit('close', true);
                        }).catch(() => {
                            this.afterCloseResult(data.id);
                            //this.$emit('close', true)
                        })
                    })
            },

            lastOne(){
                this.number > 1 && this.number--;
            },
            nextOne(){
                this.number < this.topics.length && this.number++;
            },
            toNumber(n) {
                this.number = n;

                if (this.multiMode) {
                    this.$scrollElement.scrollTop($("[index=" + (n-1) + "]").position().top - 15);
                }
            },
            sheetStatus(topicID) {
                let status = '';
                let topic = this.response[topicID];

                let singleHasContent = topic && typeof topic === 'number';
                let multiHasContent = Array.isArray(topic) && topic.length;

                if (singleHasContent || multiHasContent) {
                    status = 'check';
                }

                return status;
            },

            initKeyboard() {
                $(document).on('keydown.paper', e => {
                    let key = e.keyCode
                    if (this.multiMode) return
                    if (key === 37) {
                        this.lastOne()
                    }
                    if (key === 39) {
                        this.nextOne()
                    }
                })
            },

            closeFn(){
                screenfull.exit();
                this.$emit('close', false);
            },
            afterCloseResult(id) {
                this.$emit('close-result', id);
            }
        },

        beforeDestroy() {
            $(document).off('keydown.paper')
        },
    }
</script>

<style lang="scss">
    @import './Paper';



</style>
